import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Identifier, Group, IdentifierType, IValueViewModel } from '../../../models';
import { ILoggerService, IStoreService } from '../../../services';
import { identifierSaved } from '../../../common';

interface IDuplicateFormCtrl extends angular.IFormController {
    newGroupName: angular.INgModelController;
}

class DuplicateIdentifierModalController implements angular.IComponentController {
    identifier: Identifier;
    groups: Group[];
    targetGroup: Group;
    identifiers: Identifier[];
    formCtrl: IDuplicateFormCtrl;
    modalId: string;
    newIdentifierName: string;
    newTagDefinitionGuid: string;
    identifierType = IdentifierType;

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        '$rootScope',
        '$timeout',
        'storeService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _$timeout: angular.ITimeoutService,
        private _storeService: IStoreService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this._$timeout(() => this.bindModalEvents());
    }


    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['identifier'] && changesObj['identifier'].currentValue) {
            this.newIdentifierName = this.identifier.name;
            this.newTagDefinitionGuid = this.identifier.tagDefinitionGuid;
            this.validateName();
        }
    }

    createFrom() {
        this._storeService.dispatchers().identifiers
            .duplicate(
                this.identifier,
                this.targetGroup,
                this.newIdentifierName,
                this.newTagDefinitionGuid
            )
            .then(identifier => {
                this._loggerService.logSuccess('Identifier successfully created!');
                this._$rootScope.$broadcast(identifierSaved, identifier);
            })
            .catch(() => {
                this._loggerService.logError('Failed to create identifier');
            })
            .finally(() => this.newIdentifierName = '');

        return true;
    }

    validateName() {
        this.checkDuplicate();
    }

    filterTag(list: IValueViewModel[]): IValueViewModel[] {
        return list;
    }

    private checkDuplicate() {
        let isValid = false;
        try {
            if (this.formCtrl.newIdentifierName) {
                const name = this.formCtrl.newIdentifierName.$viewValue.toLowerCase();
                const targetGroup = this.groups.filter(g => g.guid === this.targetGroup.guid)[0];
                const alreadyExisting = targetGroup.identifierCollection.filter(i => !i['isCreating']);
                //(i as any).isCreating);
                isValid = !_.some(alreadyExisting, t => t.name.toLowerCase() === name);
            }
        }
        catch {
            isValid = false;
        }
        finally {
            this.formCtrl.newIdentifierName.$setValidity('duplicate', isValid);
        }
    }

    private bindModalEvents() {
        angular.element(`#${this.modalId}`).on('hidden.bs.modal', () => {
            this.formCtrl.$setPristine();
            this._$scope.$apply();
        });

        angular.element(`#${this.modalId}`).on('shown.bs.modal', () => {
            this.formCtrl.newIdentifierName.$setValidity('duplicate', false);
            this._$scope.$apply();
        });
    }
}

export const wtDuplicateIdentifierModal: ComponentDefinition = {
    componentId: 'wtDuplicateIdentifierModal',
    controller: DuplicateIdentifierModalController,
    template: require('./duplicateIdentifierModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        identifier: '<',
        identifiers: '<',
        groups: '<',
        targetGroup: '<',
        modalId: '@'
    }
};